<div
  class="orgApp-mng-dept-container orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16"
>
  <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16">
    <div class="orgApp-d-flex orgApp-justify-c-spc-btw orgApp-gap-16">
      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8">
        <h2 mat-dialog-title class="orgApp-mng-dept-heading">
          <b>{{ data.title | translate }}</b>
        </h2>
        <p
          class="orgApp-mng-dept-padding orgApp-sub-title-sm orgApp-mng-dept-sub-title"
        >
          {{ data.subTitle | translate }}
        </p>
      </div>
      <div>
        <button
          type="button"
          mat-icon-button
          style="background-color: white"
          (click)="cancelForm((((data?.type === 'memberType' || (data?.dialogType === 'manage_dept')) && (this.enableSave || this.isAddEnabled || this.isEditing))) ? 'reset' : undefined)"
        >
        <svg width="24" height="24">
          <use xlink:href="#close-icon"></use>
        </svg>
        </button>
      </div>
    </div>
  </div>
  <mat-dialog-content class="mat-typography orgApp-mng-dept-main-div">
    <div class="orgApp-mng-dept-padding orgApp-mng-dept-form">
      @if(manageDataForm){
        <form 
          [formGroup]="manageDataForm"
          class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-48"
        >
          <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-24">
            @if (canEditOrganisation) {
            <div
              class="orgApp-mng-dept-form-field-div orgApp-d-flex orgApp-gap-8 orgApp-align-i-center"
            >
              @if(!showIcon){
                @if (data?.dialogType ==='manage_dept') {

                  <div class="orgApp-mbrty-add-div">
                    @if(!showNewForm){
                      <div class="orgApp-d-flex orgApp-gap-16 orgApp-align-i-center">
                        <p class="orgApp-mbrty-p orgApp-mng-dlg-inact-clr orgApp-margin">{{"location.manage_dept-dialog.content.new_department" | translate}}</p>
                        <button
                        mat-icon-button
                        class="orgApp-mng-dept-btn orgApp-md-add-btn orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-icon-btn-primary"
                        (click)="openNewDataForm()" >
                        <svg width="20" height="20">
                          <use xlink:href="#add-icon"></use>
                        </svg>
                        </button>
                      </div>
                    }
                    @else {
                      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16">
                        <mat-form-field  floatLabel="always"  appearance="outline"
                        class="orgApp-mbrty-form-field orgApp-field-height orgApp-field-rounded-sm orgApp-field-border-color orgApp-new-dept-field create-manager-field"
                        [ngClass]="{ 'orgApp-error-field': dataExistsError, 'orgApp-mng-dept-form-field-m': data?.dialogType === 'manage_dept'}"
                        >
                          <mat-label>{{ data.label | translate }}</mat-label>
                          <input matInput formControlName="data" (input)="validateNewData()"/>
                          <div *ngIf="dataExistsError" class="orgApp-error-message orgApp-mng-dialog-error-text">
                            {{ data?.errorMsg | translate }}
                          </div>
                        </mat-form-field>
                    
                        <div class="orgApp-d-flex orgApp-mbrty-action-div orgApp-mbrty-form-field">
                          <mat-slide-toggle formControlName="active" class="orgApp-toggle-color orgApp-mng-d-tgle-h-24">
                            {{ "location.manage_dept-dialog.action.activate" | translate}}
                          </mat-slide-toggle>
                          <div class="orgApp-d-flex orgApp-gap-8 orgApp-margin-left-auto">
                            <button
                            class="orgApp-mbrty-close-btn orgApp-mbrty-button"
                            mat-stroked-button
                            color="primary"
                            (click)="cancelForm('newForm')"
                          >
                            {{ "location.manage_dept-dialog.action.close" | translate }}
                          </button>
                          <button
                            mat-raised-button
                            [ngClass]="{
                              disable: !isAddEnabled
                            }"
                            class="orgApp-raised-btn-primary orgApp-mbrty-button orgApp-mbrty-add-button"
                            [disabled]="!isAddEnabled"
                            (click)="addNewData()"
                          >
                            <svg width="20" height="20"><use xlink:href="#add-icon-white"></use></svg>
                             {{ "location.manage_dept-dialog.action.create" | translate }}

                          </button>
                          </div>
                       </div>
                      </div>
                    }
                  </div>
                }
                @else if(data?.type==='memberType'){
                  <div class="orgApp-mbrty-add-div">
                    @if(!showNewForm){
                      <div class="orgApp-d-flex orgApp-gap-16 orgApp-align-i-center">
                        <p class="orgApp-mbrty-p orgApp-mng-dlg-inact-clr orgApp-margin">{{"duties.manage_member-type-dialog.content.new_member"|translate}}</p>
                        <button
                        mat-icon-button
                        class="orgApp-mng-dept-btn orgApp-md-add-btn orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-icon-btn-primary"
                        (click)="openNewDataForm()" >
                        <svg width="20" height="20">
                          <use xlink:href="#add-icon"></use>
                        </svg>
                        </button>
                      </div>
                    }
                    @else{
                      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16">
                        <mat-form-field  floatLabel="always"  appearance="outline"
                        class="orgApp-mbrty-form-field orgApp-field-height orgApp-field-rounded-sm orgApp-field-border-color orgApp-new-dept-field"
                        [ngClass]="{
                          'orgApp-error-field': dataExistsError,
                          'orgApp-mng-dept-form-field-m': data?.dialogType === 'manage_dept'
                        }"
                        >
                          <mat-label>{{ data.label | translate }}</mat-label>
                          <input matInput formControlName="data" (input)="validateNewData()"/>
                          <div *ngIf="dataExistsError" class="orgApp-error-message orgApp-mng-dialog-error-text">
                            {{ data?.errorMsg | translate }}
                          </div>
                        </mat-form-field>
                        <mat-form-field floatLabel="always"  appearance="outline">
                          <mat-label>{{ 'location.manage_dept-dialog.label.duty_covered_by' | translate }}</mat-label>
                          <mat-select
                            formControlName="dutyCoveredByMemberTypes"
                            placeholder="{{ 'location.manage_dept-dialog.placeholder.duty_covered_by' | translate }}"
                            class="orgApp-es-pract-drpdwn"
                            multiple
                          >
                            <mat-select-trigger>
                              <ng-container *ngIf="selectedNames?.length as count">
                                <ng-container *ngIf="count === 1">
                                  {{ selectedNames[0] }}
                                </ng-container>
                                <ng-container *ngIf="count > 1">
                                  {{ selectedNames[0] }} +({{ count - 1 }}
                                  {{ 'location.manage_dept-dialog.content.others' | translate }})
                                </ng-container>
                              </ng-container>
                            </mat-select-trigger>
                            @for (data of dialogListData; track data) {
                            <mat-option [value]="data.id">
                              <div class="orgApp-d-flex orgApp-gap-8">
                                <span class="orgApp-duty-option-span">
                                  {{ data.value }}</span
                                >
                              </div>
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <div class="orgApp-d-flex orgApp-gap-16">
                          <mat-checkbox
                          color="primary"
                          class="orgApp-mbrty-checkbox"
                          formControlName="isManager"
                          >{{"duties.manage_member-type-dialog.content.set_manager"|translate}}</mat-checkbox>
                          <svg class="orgApp-margin-top-6"
                          (mouseenter)="showToolTip = true"
                          (mouseleave)="showToolTip = false"
                          [attr.xlink:href]="showToolTip ? '#filled-info' : '#info'"
                          matTooltip="{{ 'duties.manage_member-type-dialog.content.tooltip'|translate }}"
                          matTooltipPosition="above"
                          width="20"
                          height="20"
                        >
                          <use [attr.xlink:href]="showToolTip ? '#filled-info' : '#info'"></use>
                        </svg>
                        </div>
                        <div class="orgApp-d-flex orgApp-mbrty-action-div orgApp-mbrty-form-field">
                          <mat-slide-toggle formControlName="active" class="orgApp-toggle-color orgApp-mng-d-tgle-h-24">{{"duties.manage_member-type-dialog.content.activate"|translate}}</mat-slide-toggle>
                          <div class="orgApp-d-flex orgApp-gap-8 orgApp-margin-left-auto">
                            <button
                            class="orgApp-mbrty-close-btn orgApp-mbrty-button"
                            mat-stroked-button
                            color="primary"
                            (click)="cancelForm('newForm')"
                          >
                            {{ "location.manage_dept-dialog.action.close" | translate }}
                          </button>
                          <button
                            mat-raised-button
                            [ngClass]="{
                              disable: !isAddEnabled
                            }"
                            class="orgApp-raised-btn-primary orgApp-mbrty-button orgApp-mbrty-add-button"
                            [disabled]="!isAddEnabled"
                            (click)="addNewData()"
                          >
                          <svg width="20" height="20">
                          <use xlink:href="#add-icon-white"></use>
                        </svg>
                            {{ "location.manage_dept-dialog.action.create" | translate }}
                          </button>
                          </div>
                          </div>
                      </div>
                    }
                    
                  </div>
                }
                @else if(data?.dialogType ==='manage_duties'){
                  @if(!showNewForm){
                  <div class="orgApp-mbrty-add-div">
                    <div class="orgApp-d-flex orgApp-gap-16 orgApp-align-i-center">
                      <p class="orgApp-mbrty-p orgApp-mng-dlg-inact-clr orgApp-margin">{{"location.manage_duties-dialog.new"|translate}}</p>
                      <button
                      mat-icon-button
                      class="orgApp-mng-dept-btn orgApp-md-add-btn orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-icon-btn-primary"
                      (click)="createNewDuty()" >
                      <svg width="20" height="20">
                        <use xlink:href="#add-icon"></use>
                      </svg>
                      </button>
                    </div>
                  </div>
                  }
                }
              
              } @else{
              <button
                mat-stroked-button
                class="orgApp-stroked-btn-primary-md orgApp-mi-new-i-btn"
                (click)="addIconData(data?.modalData, false)"
              >
                <svg width="20" height="20">
                  <use xlink:href="#add-icon"></use>
                </svg>
                {{ data?.buttonName | translate }}
              </button>
              }
            </div>
            }
            <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16">
              <div class="orgApp-d-flex orgApp-flex-dir-col">
                <h3 class="orgApp-mng-dept-heading orgApp-mng-dept-sub-heading">
                  {{ data.listTitle | translate }}
                </h3>
                @if(data?.type==='memberType' && canEditOrganisation){
                  <p class="orgApp-sub-title-sm orgApp-margin">
                    {{ "staff.manage_member-type-dialog.sub_title3" | translate }}
                  </p>
                }
              </div>
              <div
                formArrayName="name"
                class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16"
                [ngClass]="{
                  'orgApp-mng-dept-div': data?.type === 'memberType'
                }"
              >
                @if(data?.type==='memberType'){
                <div cdkDropListGroup>
                  <div
                    cdkDropList class="card-container" (cdkDropListDropped)="drop($event)" [cdkDropListData]="dialogListData"
                    class="orgApp-d-flex orgApp-flex-dir-col"
                  >
                    <div cdkDrag (cdkDragStarted)="onDragStart(i)"  (cdkDragMoved)="autoScroll($event)"
                        (cdkDragEnded)="onDragEnd(i)"
                        [cdkDragDisabled]="editMode[i] || !canEditOrganisation"
                      class="orgApp-d-flex orgApp-gap-8 orgApp-align-i-center orgApp-mng-dept-div-padding"
                      [ngClass]="{
                        'orgApp-mng-dept-field-div': i < dialogListData.length - 1,
                        'orgApp-mng-dept-div-no-padding': editMode[i],
                        'orgApp-mbrty-div-padding': !departmentCtrl?.isManager
                      }"
                      *ngFor="let departmentCtrl of dialogListData; let i = index"
                    >
                      @if(departmentCtrl?.isManager && !editMode[i]){
                        <svg width="24" height="24">
                          <use xlink:href="#manager-rep"></use>
                        </svg>
                      }
                      @if(editMode[i]){
                        <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16" >
                          <div class="orgApp-d-flex orgApp-gap-10 orgApp-align-i-center">  
                          @if(departmentCtrl?.isManager){
                            <svg width="24" height="24">
                              <use xlink:href="#manager-rep"></use>
                            </svg>
                          }
                          <mat-form-field
                          floatLabel="always"
                          appearance="outline"
                          class="orgApp-mbrty-p-s orgApp-field-height orgApp-field-rounded-sm orgApp-field-border-color orgApp-new-dept-field"
                          [ngClass]="{
                            'orgApp-error-field': dataEditExistError[i],
                            'orgApp-mng-dept-field': showIcon,
                            'orgApp-red-border': isDragging[i],
                            'orgApp-mng-dept-form-field-m': data?.dialogType === 'manage_dept'|| data?.type==='memberType'
                          }">
                          <input
                            matInput
                            class="orgApp-mi-i-name"
                            [formControlName]="i"
                            [disabled]="!editMode[i]"
                            (input)="validateEditData(i, $event)"
                          />
                          <div
                            *ngIf="dataEditExistError[i]"
                            class="orgApp-error-message orgApp-error-msg-div"
                          >
                            {{ data?.errorMsg | translate }}
                          </div>
                          </mat-form-field>
                          <mat-slide-toggle  [disabled]="departmentCtrl?.disabled" [checked]="departmentCtrl?.active" class="orgApp-toggle-color orgApp-mng-d-tgle-h-24"></mat-slide-toggle>
                          <div class="orgApp-d-flex orgApp-gap-8">
                            <button
                              mat-icon-button
                              (click)="cancelUpdation(i, departmentCtrl)"
                              class="orgApp-mng-dept-btn orgApp-justify-c-center orgApp-mng-dept-close-btn orgApp-align-i-center orgApp-mng-dept-add-btn"
                            >
                            <svg width="16"  viewBox="0 0 16 16" height="16">
                              <use xlink:href="#close-blue-icon"></use>
                            </svg>
                            </button>
                            <button
                              mat-icon-button
                              [disabled]="dataEditExistError[i] || !isUpdateEnabled"
                              [ngClass]="{ disable: dataEditExistError[i] || !isUpdateEnabled }"
                              (click)="updateData(i, departmentCtrl)"
                              class="orgApp-mng-dept-btn orgApp-justify-c-center orgApp-align-i-center orgApp-mng-dept-add-btn orgApp-mng-dept-check-btn"
                            >
                                <svg width="14" height="14" viewBox="0 0 20 20">
                                  <use [attr.xlink:href]="dataEditExistError[i] || !isUpdateEnabled ? '#check-grey-icon' : '#check-white-icon'"></use>
                                </svg>
                            </button>
                          </div>
                          </div>
                          <mat-form-field floatLabel="always"  appearance="outline" class="orgApp-duty-coverrage-field"  
                          [ngClass]="{ 'orgApp-margin-left-32': departmentCtrl?.isManager }">
                          <mat-label>{{ 'location.manage_dept-dialog.label.duty_covered_by' | translate }}</mat-label>
                          <mat-select
                            placeholder="{{ 'location.manage_dept-dialog.placeholder.duty_covered_by' | translate }}"
                            [value]="departmentCtrl.dutyCoveredByMemberTypes"
                            class="orgApp-es-pract-drpdwn"
                            multiple
                            (selectionChange)="updateMmemberTypeSelection($event, departmentCtrl)"
                          >
                            <mat-select-trigger>
                              <ng-container *ngIf="departmentCtrl.dutyCoveredByMemberTypes?.length as count">
                                <ng-container *ngIf="count === 1">
                                  {{ getMemberTypeName([departmentCtrl.dutyCoveredByMemberTypes[0]]) }}
                                </ng-container>
                                <ng-container *ngIf="count > 1">
                                  {{ getMemberTypeName([departmentCtrl.dutyCoveredByMemberTypes[0]]) }} +({{ count - 1 }}
                                  {{ 'location.manage_dept-dialog.content.others' | translate }})
                                </ng-container>
                              </ng-container>
                            </mat-select-trigger>
                            @for (data of getFilteredMemberTypes(departmentCtrl.id);; track data) {
                            <mat-option [value]="data.id">
                              <div class="orgApp-d-flex orgApp-gap-8">
                                <span class="orgApp-duty-option-span">
                                  {{ data.value }}</span>
                              </div>
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                          <div class="orgApp-d-flex orgApp-gap-16"
                          [ngClass]="{
                            'orgApp-margin-left-32': departmentCtrl?.isManager
                          }">
                            <mat-checkbox (change)="changeManagerSel($event.checked)"
                            color="primary"
                            class="orgApp-mbrty-checkbox"
                            [checked]="departmentCtrl?.isManager"
                            >{{"duties.manage_member-type-dialog.content.set_manager"|translate}}</mat-checkbox>
                            <svg class="orgApp-margin-top-6"
                            (mouseenter)="showToolTip = true"
                            (mouseleave)="showToolTip = false"
                            [attr.xlink:href]="showToolTip ? '#filled-info' : '#info'"
                            matTooltip="{{ 'duties.manage_member-type-dialog.content.tooltip'|translate }}"
                            matTooltip
                            matTooltipPosition="above"
                            width="20"
                            height="20"
                          >
                            <use [attr.xlink:href]="showToolTip ? '#filled-info' : '#info'"></use>
                          </svg>
                          </div>
                        </div>                  
                      }
                      @else{
                        <p class="orgApp-mbrty-p orgApp-margin orgApp-mng-dlg-act-clr"
                        [ngClass]="{'orgApp-mbrty-p-s':departmentCtrl.isManager, 'orgApp-mng-dlg-inact-clr':!departmentCtrl?.active}"
                        >{{departmentCtrl.value}}</p>
                        <mat-slide-toggle [checked]="departmentCtrl?.active" [disabled]="departmentCtrl?.disabled" (change)="toggleActive('memberType',departmentCtrl?.id, $event.checked)"
                      class="orgApp-toggle-color orgApp-mng-d-tgle-h-24"
                    ></mat-slide-toggle>
                      }
                      @if(!editMode[i]){
                      <button [disabled]="!canEditOrganisation"
                        class="orgApp-mng-dept-btn orgApp-mng-dept-action-btn orgApp-align-i-center orgApp-justify-c-center orgApp-mng-dialog-edit-btn"
                        mat-icon-button (click)="toggleEdit(i, departmentCtrl)"
                      >
                      <svg width="16"  [attr.viewBox]=" !canEditOrganisation ? '0 0 18 18' : (data?.type === 'memberType' && departmentCtrl?.active === false) ? '0 0 16 16' : '0 0 14 14'" height="16">
                        <use [attr.xlink:href]="canEditOrganisation?'#edit-icon-dark':'#edit-icon-disabled'"></use>
                      </svg>
                      </button>
                      <button
                        class="orgApp-mng-dept-btn orgApp-mng-dialog-delete-btn orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-mng-dept-action-btn"
                        mat-icon-button
                        [disabled]="!deleteMode[i] || !canEditOrganisation"
                        (click)="deleteData(i, departmentCtrl)"
                      >
                          <svg width="20" height="20">
                            <use [attr.xlink:href]="(deleteMode[i] && canEditOrganisation)  ? '#delete-outline-grey-icon' : '#delete-outline-disabled'"></use>
                          </svg>
                        </button>
                      } 
                    </div>
                  </div>
                </div>
                } @else{
                <div *ngFor="let departmentCtrl of dialogListData; let i = index">
                  <div class="orgApp-mng-dept-form-field-div orgApp-d-flex orgApp-gap-8 orgApp-align-i-center">
                    @if(showIcon){
                    <div
                      class="orgApp-mng-dialog-icon orgApp-align-i-center orgApp-justify-c-center"
                      [ngStyle]="{'background-color': departmentCtrl.colourCode}"
                    >
                    @if(departmentCtrl?.iconType !== 'text'){
                      <svg width="24" height="24">
                        <use [attr.xlink:href]="'#' + departmentCtrl.icon"></use>
                      </svg>
                    }
                    @else{
                      <span [ngStyle]="{ color: departmentCtrl?.iconColour }">
                        {{departmentCtrl.icon}}
                      </span>
                    }
                    </div>
                    }
                    @if (data?.dialogType === 'manage_dept') {
                    <mat-slide-toggle [checked]="departmentCtrl?.active" [disabled]="departmentCtrl?.disabled" (change)="toggleActive('department',departmentCtrl?.id, $event.checked)"
                      class="orgApp-toggle-color orgApp-mng-d-tgle-h-24"
                    ></mat-slide-toggle>
                    }
                    <mat-form-field
                      floatLabel="always"
                      appearance="outline"
                      class="orgApp-mng-dept-form-field orgApp-field-height orgApp-field-rounded-sm orgApp-field-border-color orgApp-new-dept-field"
                      [ngClass]="{
                        'orgApp-error-field': dataEditExistError[i],
                        'orgApp-mng-dept-field': showIcon,
                        'orgApp-mng-dept-form-field-m': data?.dialogType === 'manage_dept'
                      }"
                    >
                      <input
                        matInput
                        class="orgApp-mi-i-name"
                        [formControlName]="i"
                        [disabled]="!editMode[i]"
                        (input)="validateEditData(i, $event)"
                      />
                      <div
                        *ngIf="dataEditExistError[i]"
                        class="orgApp-error-message"
                      >
                        {{ data?.errorMsg | translate }}
                      </div>
                    </mat-form-field>
                    @if(!editMode[i] || editMode[i] && this.data?.dialogRef === this.manageDialogRef.Indicator){
                    <button
                      class="orgApp-mng-dept-btn orgApp-mng-dialog-icon orgApp-align-i-center orgApp-justify-c-center orgApp-mng-dialog-edit-btn orgApp-mng-dept-action-btn"
                      mat-icon-button
                      (click)="toggleEdit(i, departmentCtrl)" [disabled]="!canEditOrganisation"
                    >
                    <svg width="16"  [attr.viewBox]=" !canEditOrganisation ? '0 0 18 18' : (data?.dialogType === 'manage_dept' && departmentCtrl?.active === false) ? '0 0 16 16' : '0 0 14 14'" height="16">
                      <use [attr.xlink:href]="canEditOrganisation ? '#edit-icon-dark':'#edit-icon-disabled'"></use>
                    </svg>
                    </button>
                    <!-- adding span to show tooltip for a disabled button -->
                    <span
                      [matTooltip]="departmentCtrl?.isMappedToAnyEvent ? (data?.deleteToolTip | translate) : ''"
                      matTooltipPosition="above"
                    >
                      <button
                        class="orgApp-mng-dept-btn orgApp-mng-dialog-delete-btn orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-mng-dept-action-btn"
                        mat-icon-button
                        [disabled]="!deleteMode[i] || !canEditOrganisation || departmentCtrl?.isMappedToAnyEvent" (click)="deleteData(i, departmentCtrl)"
                      >
                        <svg width="20" height="20">
                          <use [attr.xlink:href]="((deleteMode[i] && canEditOrganisation) && !departmentCtrl?.isMappedToAnyEvent) ? '#delete-outline-grey-icon' : '#delete-outline-disabled'"></use>
                        </svg>
                        </button
                      >
                    </span>
                    } @if(editMode[i] && !(this.data?.dialogRef === this.manageDialogRef.Indicator)){
                    <button
                      mat-icon-button
                      (click)="cancelUpdation(i, departmentCtrl)"
                      class="orgApp-mng-dept-btn orgApp-mng-dept-close-btn orgApp-align-i-center orgApp-justify-c-center orgApp-mng-dept-add-btn"
                    >
                    <svg width="16"  viewBox="0 0 16 16" height="16">
                      <use xlink:href="#close-blue-icon"></use>
                    </svg>
                    </button>
                    <button
                      mat-icon-button
                      [disabled]="dataEditExistError[i] || !isUpdateEnabled || (data?.dialogType === 'manage_dept' && !isControlDirty(i))"
                      [ngClass]="{
                        disable: dataEditExistError[i] || !isUpdateEnabled || (data?.dialogType === 'manage_dept' && !isControlDirty(i))
                      }"
                      (click)="updateData(i, departmentCtrl)"
                      class="orgApp-mng-dept-btn orgApp-mng-dept-add-btn orgApp-align-i-center orgApp-justify-c-center orgApp-mng-dept-check-btn"
                    >
                      <svg width="14" height="14" viewBox="0 0 20 20">
                        <use [attr.xlink:href]="dataEditExistError[i] || !isUpdateEnabled || (data?.dialogType ==='manage_dept' && !isControlDirty(i)) ? '#check-grey-icon' : '#check-white-icon'"></use>
                      </svg>
                      </button
                    >}
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </form>
      }
      @else{
         <div class="orgApp-load-mng-dlg">
            <mat-spinner></mat-spinner>
          </div>
      }
    </div>
  </mat-dialog-content>

  @if(data?.type==='memberType' && showButtonCont){
  <mat-dialog-actions class="orgApp-d-flex orgApp-mng-dept-btn-div">
    <div class="orgApp-margin-right-16 orgApp-d-flex orgApp-gap-8">
      <button
        mat-stroked-button
         [ngClass]="{
          disable: !enableSave
        }"
        [disabled]="!enableSave"
        class="orgApp-add-d-ftr-btn orgApp-add-d-close-btn orgApp-modal-button orgApp-add-d-graphik-text"
        (click)="cancelForm('reset')"
      >
        {{"duties.manage_member-type-dialog.action.reset"|translate}}
      </button>
      <button
        mat-raised-button
         [ngClass]="{
          disable: !enableSave
        }"
        [disabled]="!enableSave"
        class="orgApp-raised-btn-primary orgApp-add-d-ftr-btn orgApp-add-d-create-btn orgApp-modal-button orgApp-add-d-graphik-text"
        (click)="submitForm()"
      >
      {{"duties.manage_member-type-dialog.action.save"|translate}}
      </button>
    </div>
  </mat-dialog-actions>
  }
</div>